import { render, staticRenderFns } from "./vgtree1.vue?vue&type=template&id=5f6d80ce&scoped=true&"
import script from "./vgtree1.vue?vue&type=script&lang=js&"
export * from "./vgtree1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6d80ce",
  null
  
)

export default component.exports